import PaymentsService from "@/services/payments";
import serviceHandler from "@/helpers/handlers/service";

export default {
  initializeOrder({ state, commit }, companyId) {
    if (state.orderCompanyId === companyId) return true;
    commit("RESET_ORDER_DRAFT", companyId);
    return false;
  },
  async getPlans({ commit }) {
    const data = await serviceHandler(PaymentsService.getPlans());

    commit("SET_PLANS", data.plans);
    commit("SET_LIMITS_USAGE", data.limits_usage);

    const [plan] = data.plans;
    const [price] = plan.prices;
    const currency = price.currency;
    commit("SET_CURRENCY", currency.toUpperCase());
  },

  async getPricePreview({ commit, state, getters }) {
    const request = state.pricePreviewRequest + 1;
    const companyId = state.orderCompanyId;
    commit("SET_PRICE_PREVIEW_REQUEST", request);
    if (!Object.keys(state.selectedPlan).length) {
      commit("SET_PRICE_PREVIEW", 0);
      commit("SET_TAX_PRICE", 0);

      return false;
    }
    const data = await serviceHandler(
      PaymentsService.getPricePreview({
        currency: state.currency,
        items: [
          {
            price: state.selectedPlan.prices.find(item => {
              return item.recurring.interval === state.selectedPeriod;
            }).price_id,
            quantity: state.selectedLocationsCount
          }
        ],
        ...(!getters.isFreePlan &&
          state.promoCode && { promotion_code: state.promoCode })
      })
    );
    if (
      !data ||
      request !== state.pricePreviewRequest ||
      companyId !== state.orderCompanyId
    )
      return false;
    commit("SET_PRICE_PREVIEW", data.amount_due);
    commit("SET_TAX_PRICE", data.tax);
    return true;
  },
  async setSelectedPlan({ commit }, payload) {
    commit("SET_SELECTED_PLAN", payload);
  },
  async setSelectedLocationsCount({ commit }, payload) {
    commit("SET_SELECTED_LOCATIONS_COUNT", payload);
  },
  async setSelectedPeriod({ commit }, payload) {
    commit("SET_SELECTED_PERIOD", payload);
  },
  async setSelectedPaymentMethod({ commit }, payload) {
    commit("SET_SELECTED_PAYMENT_METHOD", payload);
  },
  async getInitialChosenPlan({ commit }) {
    commit("SET_INITIAL_CHOSEN_PLAN", null);
    const { data: plan } = await PaymentsService.getInitialChosenPlan();
    commit("SET_INITIAL_CHOSEN_PLAN", plan || null);
  },
  async getPromotionCodes({ commit }) {
    const data = await serviceHandler(PaymentsService.getPromotionCodes());
    commit("SET_PROMOTION_CODES", data.length ? data : null);
  },
  setPromoCode({ commit }, payload) {
    commit("SET_PROMO_CODE_EDITED", true);
    commit("SET_PROMO_CODE", payload.trim());
  },
  applyCampaignPromoCode({ commit, state, getters }) {
    if (state.promoCodeEdited) return;
    commit("SET_PROMO_CODE", getters.promotionCode);
  },
  setPlanChangeType({ commit }, payload) {
    commit("SET_PLAN_CHANGE_TYPE", payload);
  },
  setInitialPlanIndex({ commit }, payload) {
    commit("SET_INITIAL_PLAN_INDEX", payload);
  }
};
